var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.processing)?_c('a',{class:_vm.buttonClass,domProps:{"innerHTML":_vm._s(_vm.buttonContent)},on:{"click":function($event){$event.preventDefault();return _vm.call.apply(null, arguments)}}}):_c('span',{class:_vm.cssClassProcessing},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(_vm._s(_vm.computedLabelProcessing)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }